module.exports = __webpack_public_path__ + "static/media/2_menuU_86,35_3,7.9c30ebfc.png";